let imgSrc = require('./imgSrc');
let level = {
  normal: 'normal',
  mild: 'mild',
  severe: 'severe'
}

function initRiskBar(option) {
  let canvas = option.element;
  //console.log('option =>', option);
  canvas.width = 200;
  canvas.height = 100;
  let cxt = canvas.getContext('2d');

  cxt.save();
  cxt.translate(0, 40);
  // 第一部分
  cxt.save();
  cxt.fillStyle = '#57d90b';
  cxt.beginPath();
  cxt.moveTo(0, 0);
  cxt.lineTo(60, 0);
  cxt.lineTo(60, 20);
  cxt.lineTo(0, 20);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  // 第二部分
  cxt.save();
  cxt.fillStyle = '#ff7200';
  cxt.beginPath();
  cxt.moveTo(70, 0);
  cxt.lineTo(130, 0);
  cxt.lineTo(130, 20);
  cxt.lineTo(70, 20);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  // 第三部分
  cxt.save();
  cxt.fillStyle = '#c91004';
  cxt.beginPath();
  cxt.moveTo(140, 0);
  cxt.lineTo(200, 0);
  cxt.lineTo(200, 20);
  cxt.lineTo(140, 20);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  cxt.restore();

  // 画顶部箭头
  let img = new Image();
  //console.log('option.level=>', option.level);
  switch (option.level) {
    case 'normal':
      img.src = imgSrc.riskbar_arrow.low;
      img.onload = function () {
        cxt.drawImage(img, 20, 0, 20, 25);
      }
      break;
    case 'mild':
      img.src = imgSrc.riskbar_arrow.middle;
      img.onload = function () {
        cxt.drawImage(img, 90, 0, 20, 25);
      }
      break;
    case 'severe':
      img.src = imgSrc.riskbar_arrow.high;
      img.onload = function () {
        cxt.drawImage(img, 160, 0, 20, 25);
      }
      break;
  }
}

function initRiskLevel(option) {
  //console.log('el =>', option.width);
  let canvas = option.el;
  let cxt = canvas.getContext('2d');
  let scaleW = option.width / 216;
  let scaleH = option.height / 30;
  let scale = scaleW < scaleH ? 2 * scaleW : 2 * scaleH;
  canvas.width = 216 * scale;
  canvas.height = 30 * scale;
  canvas.style.width = 216 * scale / 2 + 'px';
  canvas.style.height = 30 * scale / 2 + 'px';
  let value = Number(canvas.dataset.value);
  value = Math.floor(value);
  //console.log('color =>', option.color);
  //console.log('level =>', option.level);
  let color = option.color[canvas.dataset.level];
  let valueX = value / 100 * 190 + 5;
  let lowToMidX = 20 / 100 * 190 + 5;
  let midToHighX = 60 / 100 * 190 + 5;
  cxt.scale(scale, scale);
  cxt.translate(8, 0);

  // 画图标和风险值

  // cxt.save();
  // let icon = imgSrc.RISKBAR_ICON;
  // let img = new Image();
  // img.src = icon;
  // img.onload = function () {
  //   cxt.drawImage(img, valueX - 5, 5, 10, 15);
  //   cxt.font = '12px sans-serif';
  //   cxt.fillStyle = '#9b9b9b';
  //   if(valueX + 5 > 170) {
  //     cxt.fillText(value, valueX - 28, 17);
  //   } else {
  //     cxt.fillText(value, valueX + 8, 17);
  //   }
  // }
  // cxt.restore();
  cxt.save();
  cxt.fillStyle = color;
  cxt.beginPath();
  cxt.moveTo(valueX - 10, 2);
  cxt.lineTo(valueX + 10, 2);

  cxt.arc(valueX + 10, 3, 1, - Math.PI / 2, 0);

  cxt.lineTo(valueX + 11, 17);

  cxt.arc(valueX + 10, 17, 1, 0, Math.PI / 2);

  cxt.lineTo(valueX + 3, 18);
  cxt.lineTo(valueX, 20);
  cxt.lineTo(valueX - 3, 18);
  cxt.lineTo(valueX - 10, 18);

  cxt.arc(valueX - 10, 17, 1, Math.PI / 2, Math.PI);

  cxt.lineTo(valueX - 11, 3);
  cxt.arc(valueX - 10, 3, 1, Math.PI, Math.PI * 3 / 2);
  cxt.closePath();
  cxt.fill();
  cxt.fillStyle = '#fff';
  cxt.textAlign = 'center';
  cxt.font = '14px serif';
  cxt.fillText(value, valueX, 15);
  cxt.restore();

  // 画柱状图灰色背景
  cxt.save();
  cxt.fillStyle = '#c1c1c1';
  cxt.beginPath();
  cxt.moveTo(7, 23);
  cxt.lineTo(193, 23);
  cxt.arc(193, 25, 2, 3 * Math.PI / 2, Math.PI / 2);
  cxt.lineTo(7, 27);
  cxt.arc(7, 25, 2, Math.PI / 2, 3 * Math.PI / 2);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  // 画线性渐变风险柱状图
  let gradient = cxt.createLinearGradient(0, 0, 190, 0);
  gradient.addColorStop(0, '#00ff6a');
  gradient.addColorStop(.38, '#ffda08');
  gradient.addColorStop(1, '#ff4d4d');

  cxt.fillStyle = gradient;
  cxt.beginPath();
  if(valueX > 5) {
    cxt.moveTo(7, 23);
    cxt.lineTo(valueX - 2, 23);
    cxt.arc(valueX - 2, 25, 2, 3 * Math.PI / 2, Math.PI / 2);
    cxt.lineTo(7, 27);
    cxt.arc(7, 25, 2, Math.PI / 2, 3 * Math.PI / 2);
  }
  cxt.closePath();
  cxt.fill();

  // 画值为 20 的分界线
  cxt.beginPath();
  cxt.strokeStyle = '#8a8b81';
  cxt.lineWidth = 2;
  cxt.moveTo(lowToMidX, 18);
  cxt.lineTo(lowToMidX, 22);
  cxt.moveTo(lowToMidX, 23);
  cxt.lineTo(lowToMidX, 27);
  cxt.moveTo(lowToMidX, 28);
  cxt.lineTo(lowToMidX, 32);
  cxt.stroke();
  cxt.closePath();

  // 画值为 60 的分界线
  cxt.beginPath();
  cxt.strokeStyle = '#8a8b81';
  cxt.lineWidth = 2;
  cxt.moveTo(midToHighX, 18);
  cxt.lineTo(midToHighX, 22);
  cxt.moveTo(midToHighX, 23);
  cxt.lineTo(midToHighX, 27);
  cxt.moveTo(midToHighX, 28);
  cxt.lineTo(midToHighX, 32);
  cxt.stroke();
  cxt.closePath();
}

// ====== 骨骼筋膜图 ======
function getRad(topOrRightPoint, bottomOrLeftPoint, isHorizontal) {
  // 此时的 right 是指看人体正面时人体的右，即我们的左；
  // 此时的 left 是指看人体正面时人体的左，即我们的右；

  let _x = Math.abs(topOrRightPoint.x - bottomOrLeftPoint.x);
  let _y = Math.abs(topOrRightPoint.y - bottomOrLeftPoint.y);
  let radian;


  if(isHorizontal) {
    if(topOrRightPoint.y < bottomOrLeftPoint.y) {
      radian = Math.atan(_y / _x);
    } else if(topOrRightPoint.y > bottomOrLeftPoint.y) {
      radian = -Math.atan(_y / _x);
    } else {
      radian = 0;
    }
  } else {
    if (topOrRightPoint.y < bottomOrLeftPoint.y) {
      // 两个点垂直位置正常情况
      if (topOrRightPoint.x > bottomOrLeftPoint.x) {
        radian = Math.atan(_x / _y);
      } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
        radian = -Math.atan(_x / _y);
      } else {
        radian = 0
      }
    } else {
      // 两个点位置垂直不正常情况
      if (topOrRightPoint.x > bottomOrLeftPoint.x) {
        radian = Math.atan(_y / _x) + Math.PI / 2;
      } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
        radian = 3 * Math.PI / 2 - Math.atan(_y / _x);
      } else {
        radian = Math.PI;
      }
    }
  }

  return radian;
}

function getLimitRad(rad, min, max) {
  if(rad > max) {
    return max;
  } else if(rad < min) {
    return min;
  } else {
    return rad;
  }
}

function isXO(risk) {
  if(risk.position === 'lower extremity' && risk.code !== 3) {
    return true;
  }
  return false;
}

function getXOLeftOrRight(risk) {
  // 此处需要注意，数据的左腿 --> 画图的右腿；数据的右腿 --> 画图的左腿
  if(risk.detail == '左腿') {
    return 'right';
  } else if(risk.detail == '右腿') {
    return 'left'
  }
}

function isHighLowShoulder(risk) {
  if (risk.position === 'shoulder' && risk.code == 1) {
    return true;
  }
  return false;
}

function getShoulderLeftOrRight(detail) {
  switch (detail) {
    case '左高':
      return 'left';
    case '右高':
      return 'right';
    default:
      return false
  }
}

function getOrderInfos(locationInfo, order) {
  let orderInfos = [];
  for(let i = 0; i < order.length; i++) {
    let pathArr = order[i].split('-');
    let info;
    for(let j = 0; j < pathArr.length; j++) {
      if(j == 0) {
        info = locationInfo[pathArr[j]];
      } else {
        info = info[pathArr[j]];
      }
    }

    orderInfos.push(info);
  }
  return orderInfos;
}

function isHeadFront(risks) {
  let riskLevel;
  risks.forEach(function(item, index) {
    if(item.position === 'head' && item.code === 2) {
      riskLevel = item.level;
    }
  })
  if(riskLevel !== level.normal) {
    return true;
  }
  return false
}

function getHeadDirection(risks) {
  let riskLevel;
  let detail;
  let direction;

  risks.forEach(function(item, index) {
    if(item.position === 'head' && item.code === 1) {
      riskLevel = item.level;
      detail = item.detail;
    }
  })

  switch (detail) {
    case '左倾':
      direction = 'right';
      break;
    case '右倾':
      direction = 'left';
      break;
    default:
      direction = 'mid';
      break;
  }

  if(riskLevel === level.severe) {
    return direction;
  } else {
    return 'mid'
  }
}

function getBodyDirection(risks) {
  let riskLevel;
  let detail;
  let direction;

  risks.forEach(function(item, index) {
    if(item.position === 'head' && item.code === 1) {
      riskLevel = item.level;
      detail = item.detail;
    }
  })

  switch (detail) {
    case '左高':
      direction = 'right';
      break;
    case '右高':
      direction = 'left';
      break;
    default:
      direction = 'mid';
      break;
  }

  if(riskLevel === level.severe) {
    return direction;
  } else {
    return 'mid'
  }
}

function firstUpperCase(str) {
  return str.toLowerCase().replace(/^[a-z]/g, (L) => L.toUpperCase());
}

// 取需要展示疼痛的部位, direction 代表正面或者侧面, data 代表后台数据中的 conclusion, pains 代表包括正面、侧面疼痛的模板
function getPainArr(direction, data, pains) {
  let risks = data.face.risks.concat(data.side.risks);
  //console.log('risks =====>',  risks);
  let painsTemplate = pains[direction];
  //console.log('painsTemplate ===>', painsTemplate);
  let painArr = [];
  for(let i = 0; i < risks.length; i++) {
    if (risks[i].level === level.severe) {
      //console.log('in severe!')
      let pains =  painsTemplate[risks[i].position][risks[i].code - 1];
      switch(direction) {
        case 'face':
          let lOrR;
          if(isXO(risks[i])) {
            lOrR = getXOLeftOrRight(risks[i]);
            //console.log('isXO ==>', lOrR)
          } else if(isHighLowShoulder(risks[i])) {
            lOrR = getShoulderLeftOrRight(risks[i].detail);
          }
          for(let j = 0; j < pains.length; j++) {
            if(lOrR === undefined) {
              painArr.push(pains[j] + '-left');
              painArr.push(pains[j] + '-right');
            } else if(typeof lOrR === 'string') {
              painArr.push(pains[j] + `-${lOrR}`)
            }
          }
          break;
        case 'side':
          painArr = painArr.concat(pains);
          break;
        default:
          break;
      }

    }
  }
  //console.log('painArr ====>', painArr)
  return painArr;
}

let pains = {
  face: {
    head: [[], ['neckPain']],
    shoulder: [['waistPain'], ['bosomPain']],
    trunk: [[]],
    pelvis: [[]],
    'lower extremity': [['thignPainForO', 'shankPain', 'hipPain'], ['thignPainForX', 'thignMidPainForX'], ['thignMidPainForKnee'], []]
  },
  side: {
    head: [[], ['neckMidPain', 'shoulderBackPain']],
    shoulder: [['neckBackPain'], ['neckWithBosomPain', 'shoulderBackPain']],
    trunk: [[]],
    pelvis: [[]],
    'lower extremity': [['shankOPain', 'thighLeftPain', 'thighRightPain'], ['shankMidPain'], ['shankLeftPain'], []]
  }
}

// ====== 正面 ======
function drawBoneFront(data, canvas) {
  //console.log('draw face begin!')
  let facePoints = data.conclusion.face.points;
  let faceRisks = data.conclusion.face.risks;

  let faceRad = {
    head: getRad(facePoints.ear.right, facePoints.ear.left, true),
    elbowToWristL:  getRad(facePoints.elbow.right, facePoints.wrist.right),
    shoulderToElbowL: getRad(facePoints.shoulder.right, facePoints.wrist.right),
    shoulder: getRad(facePoints.shoulder.right, facePoints.shoulder.left, true),
    elbowToWristR:  getRad(facePoints.elbow.left, facePoints.wrist.left),
    shoulderToElbowR: getRad(facePoints.shoulder.left, facePoints.elbow.left),
    hip: getRad(facePoints.hip.right, facePoints.hip.left, true),
    hipToKneeL: getRad(facePoints.hip.right, facePoints.knee.right),
    hipToKneeR: getRad(facePoints.hip.left, facePoints.knee.left),
    kneeToAnkleL: getRad(facePoints.knee.right, facePoints.ankle.right),
    kneeToAnkleR: getRad(facePoints.knee.left, facePoints.ankle.left),
  };

  //console.log('')
  let faceCanvas = canvas;
  //console.log('faceCanvas ==>', faceCanvas);

  let faceWidth = faceCanvas.width;
  let faceHeight = faceCanvas.height;

  //console.log('faceRad =>', faceRad)
  // let headDirection = (faceRad.head > - Math.PI / 15 && faceRad.head < Math.PI / 15) ? 'mid' : faceRad.head > Math.PI / 15 ? 'right' : 'left';
  let headDirection = getHeadDirection(faceRisks);
  //console.log('headDirection =>', headDirection);

  // let bodyDirection = (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? 'mid' : faceRad.shoulder > Math.PI / 15 ? 'right' : 'left';
  let bodyDirection = getBodyDirection(faceRisks);
  //console.log('bodyDirection =>', bodyDirection);

  // let headForBody = (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? 'forMidBody' : faceRad.shoulder > Math.PI / 15 ? 'forRightBody' : 'forLeftBody';
  let headForBody = `for${firstUpperCase(bodyDirection)}Body`;
  //console.log('headForBody =>', headForBody);

  let locationInfo = {
    head: {
      left: {
        forLeftBody: {
          key: 'head-left-forLeftBody',
          type: 'noraml',
          x: 1186,
          y: 44,
          width: 182,
          height: 188,
          offsetW: -91,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        },
        forMidBody: {   // 还需等 UI 图再确定位置
          key: 'head-left-forMidBody',
          type: 'noraml',
          x: 962,
          y: 798,
          width: 200,
          height: 168,
          offsetW: -100,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        },
        forRightBody: {
          key: 'head-left-forRightBody',
          type: 'noraml',
          x: 394,
          y: 800,
          width: 198,
          height: 179,
          offsetW: -99,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        }
      },
      mid: {
        forLeftBody: {  // 等 UI 图待定
          key: 'head-mid-forLeftBody',
          type: 'noraml',
          x: 1241,
          y: 786,
          width: 220,
          height: 186,
          offsetW: -110,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        },
        forMidBody: {
          key: 'head-mid-forMidBody',
          type: 'noraml',
          x: 938,
          y: 44,
          width: 182,
          height: 188,
          offsetW: -91,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        },
        forRightBody: {     // 等 UI 图待定
          key: 'head-mid-forRightBody',
          type: 'noraml',
          x: 1527,
          y: 784,
          width: 222,
          height: 190,
          offsetW: -111,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        }
      },
      right: {
        forLeftBody: {
          key: 'head-right-forLeftBody',
          type: 'noraml',
          x: 80,
          y: 798,
          width: 198,
          height: 179,
          offsetW: -99,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        },
        forMidBody: {   // 等 UI 图待定
          key: 'head-right-forMidBody',
          type: 'noraml',
          x: 672,
          y: 798,
          width: 202,
          height: 178,
          offsetW: -101,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        },
        forRightBody: {
          key: 'head-right-forRightBody',
          type: 'noraml',
          x: 1438,
          y: 44,
          width: 182,
          height: 188,
          offsetW: -91,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false,
        }
      }
    },
    body: {
      left: {
        key: 'body-left',
        type: 'noraml',
        x: 596,
        y: 32,
        width: 230,
        height: 344,
        offsetW: -115,
        offsetH: -40,
        translateX: 10,
        translateY: 183,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false,
      },
      mid: {
        key: 'body-right',
        type: 'noraml',
        x: 48,
        y: 32,
        width: 230,
        height: 344,
        offsetW: -115,
        offsetH: -40,
        translateX: 0,
        translateY: 183,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false,
      },
      right: {
        key: 'body-right',
        type: 'noraml',
        x: 320,
        y: 32,
        width: 230,
        height: 344,
        offsetW: -115,
        offsetH: -40,
        translateX: -10,
        translateY: 183,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false,
      }
    },
    upperArm: {
      left: {
        key: 'upperArm-left',
        type: 'noraml',
        x: 64,
        y: 462,
        width: 72,
        height: 170,
        offsetW: 0,
        offsetH: 0,
        // translateX: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? -102 : faceRad.shoulder < - Math.PI / 15 ? -105 : -95,
        translateX: -105 ,
        // translateY: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? -20 : faceRad.shoulder < - Math.PI / 15 ? -20 : -25,
        translateY: bodyDirection === 'mid' ? -20 : bodyDirection === 'left' ? -20 : -25,
        rotateBefore: 0,
        rotate: faceRad.shoulderToElbowL,
        maxRotate: 0.3,
        minRotate: -0.05,
        saveBefore: true,
        restoreAfter: false,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'upperArm-right',
        type: 'noraml',
        x: 150,
        y: 460,
        width: 72,
        height: 170,
        offsetW: -36,
        offsetH: 0,
        // translateX: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? 102 : faceRad.shoulder < - Math.PI / 15 ? 85 : 100,
        translateX: bodyDirection === 'mid' ? 102 : bodyDirection === 'left' ? 85 : 100,
        // translateY: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? -20 : faceRad.shoulder < - Math.PI / 15 ? -40 : -20,
        translateY: bodyDirection === 'mid' ? -20 : bodyDirection === 'left' ? -40 : -20,
        rotateBefore: 0,
        rotate: faceRad.shoulderToElbowR,
        maxRotate: 0.05,
        minRotate: -0.3,
        saveBefore: true,
        restoreAfter: false,
        globalCompositeOperation: 'source-over'
      }
    },
    foreArm: {
      left: {
        key: 'foreArm-left',
        type: 'noraml',
        x: 246,
        y: 464,
        width: 58,
        height: 204,
        offsetW: -38,
        offsetH: 0,
        translateX: 0,
        translateY: 162,
        rotateBefore: -faceRad.shoulderToElbowL,
        rotate: faceRad.elbowToWristL,
        maxRotate: 0.3,
        minRotate: -0.3,
        saveBefore: false,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'foreArm-right',
        type: 'noraml',
        x: 320,
        y: 464,
        width: 58,
        height: 204,
        offsetW: -24,
        offsetH: 0,
        translateX: 0,
        translateY: 162,
        rotateBefore: -faceRad.shoulderToElbowR,
        rotate: faceRad.elbowToWristR,
        maxRotate: 0.3,
        minRotate: -0.3,
        saveBefore: false,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    thigh: {
      left: {
        key: 'thigh-left',
        type: 'noraml',
        x: faceRad.shoulder < 0 ? 1065 : 464,
        y: faceRad.shoulder < 0 ? 452 : 432,
        width: 90,
        height: 296,
        offsetW: -50,
        offsetH: 0,
        // translateX: faceRad.shoulder == 0 ? -50 : faceRad.shoulder < 0 ? -55 : -50,
        translateX: bodyDirection === 'mid' ? -50 : bodyDirection === 'left' ? -55 : -50,
        // translateY: faceRad.shoulder == 0 ? 200 : faceRad.shoulder < 0 ? 210 : 190,
        translateY: bodyDirection === 'mid' ? 200 : bodyDirection === 'left' ? 210 : 190,
        rotateBefore: 0,
        rotate: faceRad.hipToKneeL,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: true,
        restoreAfter: false,
      },
      right: {
        key: 'thigh-right',
        type: 'noraml',
        x: faceRad.shoulder < 0 ? 1233 : 625,
        y: faceRad.shoulder < 0 ? 451 : 434,
        width: 90,
        height: 296,
        offsetW: -40,
        offsetH: 0,
        // translateX: faceRad.shoulder == 0 ? 45 : faceRad.shoulder < 0 ? 50 : 55,
        translateX: bodyDirection === 'mid' ? 45 : bodyDirection === 'left' ? 50 : 55,
        // translateY: faceRad.shoulder == 0 ? 200 : faceRad.shoulder < 0 ? 190 : 210,
        translateY: bodyDirection === 'mid' ? 200 : bodyDirection === 'left' ? 190 : 210,
        rotateBefore: 0,
        rotate: faceRad.hipToKneeR,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: true,
        restoreAfter: false,
      }
    },
    shank: {
      left: {
        key: 'shank-left',
        type: 'noraml',
        x: faceRad.shoulder > 0 ? 779 : 1395,
        y: faceRad.shoulder < 0 ? 443 : 441,
        width: faceRad.shoulder > 0 ? 70 : 68,
        height: faceRad.shoulder > 0 ? 306 : 300,
        offsetW: faceRad.shoulder > 0 ? -27 : -26,
        offsetH: -13,
        translateX: -5,
        translateY: 300,
        rotateBefore: -faceRad.hipToKneeL,
        rotate: faceRad.kneeToAnkleL + 0.026,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: false,
        restoreAfter: false,
      },
      right: {
        key: 'shank-right',
        type: 'noraml',
        x: faceRad.shoulder > 0 ? 904 : 1551,
        y: 444,
        width: 64,
        height: 302,
        offsetW: -40,
        offsetH: -12,
        translateX: 5,
        translateY: 300,
        rotateBefore: -faceRad.hipToKneeR,
        rotate: faceRad.kneeToAnkleR - 0.026,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: false,
        restoreAfter: false,
      }
    },
    pelvis: {
      key: 'pelvis',
      type: 'noraml',
      x: 1720,
      y: 94,
      width: 148,
      height: 120,
      offsetW: -74,
      offsetH: -40,
      translateX: 0,
      translateY: 228,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: false,
    },
    neckPain: { // --------
      left: {
        key: 'neckPain-left',
        type: 'pain',
        x: 59,
        y: 1064,
        width: 94,
        height: 36,
        offsetW: -47,
        offsetH: 0,
        translateX: -60,
        translateY: 140,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'neckPain-right',
        type: 'pain',
        x: 170,
        y: 1064,
        width: 94,
        height: 36,
        offsetW: -47,
        offsetH: 0,
        translateX: 55,
        translateY: 140,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    bosomPain: {
      left: {
        key: 'bosomPain-left',
        type: 'pain',
        x: 80,
        y: 1506,
        width: 90,
        height: 108,
        offsetW: -45,
        offsetH: 0,
        translateX: -55,
        translateY: -25,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'bosomPain-right',
        type: 'pain',
        x: 174,
        y: 1506,
        width: 90,
        height: 108,
        offsetW: -45,
        offsetH: 0,
        translateX: 55,
        translateY: -25,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    thignPainForO: {
      left: {
        key: 'thignPainForO-left',
        type: 'pain',
        x: 386,
        y: 1750,
        width: 46,
        height: 214,
        offsetW: -23,
        offsetH: 0,
        translateX: -30,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignPainForO-right',
        type: 'pain',
        x: 533,
        y: 1750,
        width: 46,
        height: 214,
        offsetW: -23,
        offsetH: 0,
        translateX: 30,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
    },
    thignPainForX: {
      left: {
        key: 'thignPainForX-left',
        type: 'pain',
        x: 80,
        y: 2110,
        width: 50,
        height: 168,
        offsetW: -25,
        offsetH: 0,
        translateX: -25,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignPainForX-right',
        type: 'pain',
        x: 214,
        y: 2110,
        width: 50,
        height: 168,
        offsetW: -25,
        offsetH: 0,
        translateX: 25,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
    },
    thignMidPainForKnee: {
      left: {
        key: 'thignMidPainForKnee-left',
        type: 'pain',
        x: 91,
        y: 1204,
        width: 52,
        height: 210,
        offsetW: -26,
        offsetH: 0,
        translateX: -10,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignMidPainForKnee-right',
        type: 'pain',
        x: 199,
        y: 1204,
        width: 52,
        height: 210,
        offsetW: -26,
        offsetH: 0,
        translateX: 10,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
    },
    thignMidPainForX: {
      left: {
        key: 'thignMidPainForX-left',
        type: 'pain',
        x: 424,
        y: 2110,
        width: 66,
        height: 180,
        offsetW: -33,
        offsetH: 0,
        translateX: 10,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignMidPainForX-right',
        type: 'pain',
        x: 495,
        y: 2110,
        width: 66,
        height: 180,
        offsetW: -33,
        offsetH: 0,
        translateX: -10,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
    },
    shankPain: {
      left: {
        key: 'shankPain-left',
        type: 'pain',
        x: 718,
        y: 1765,
        width: 36,
        height: 168,
        offsetW: -18,
        offsetH: 0,
        translateX: 0,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shankPain-right',
        type: 'pain',
        x: 808,
        y: 1765,
        width: 36,
        height: 168,
        offsetW: -18,
        offsetH: 0,
        translateX: 0,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
    },
    hipPain: {
      left: {
        key: 'hipPain-left',
        type: 'pain',
        x: 98,
        y: 1766,
        width: 64,
        height: 132,
        offsetW: -32,
        offsetH: 0,
        translateX: -40,
        translateY: -65,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shankPain-right',
        type: 'pain',
        x: 177,
        y: 1766,
        width: 64,
        height: 132,
        offsetW: -32,
        offsetH: 0,
        translateX: 45,
        translateY: -65,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    waistPain: {
      left: {
        key: 'waistPain-left',
        type: 'pain',
        x: 135,
        y: 2462,
        width: 58,
        height: 106,
        offsetW: -29,
        offsetH: 0,
        translateX: -25,
        translateY: -105,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'waistPain-right',
        type: 'pain',
        x: 255,
        y: 2462,
        width: 58,
        height: 106,
        offsetW: -29,
        offsetH: 0,
        translateX: 30,
        translateY: -105,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    restore: {
      key: 'restore',
    }
  }

  let faceOrder = [
    `head-${headDirection}-${headForBody}`,
    // 'neckPain-left',
    // 'neckPain-right',
    `body-${bodyDirection}`,
    // 'bosomPain-left',
    // 'bosomPain-right',
    // 'thigh-left',
    // 'thignPainForO-left',
    // 'thignPainForX-left',
    // 'thignMidPainForKnee-left',
    // 'thignMidPainForX-left',
    // 'shank-left',
    // 'shankPain-left',
    // 'restore',
    // 'thigh-right',
    // 'thignPainForO-right',
    // 'thignPainForX-right',
    // 'thignMidPainForKnee-right',
    // 'thignMidPainForX-right',
    // 'shank-right',
    // 'shankPain-right',
    // 'restore',
    // 'pelvis',
    // 'hipPain-left',
    // 'hipPain-right',
    // 'waistPain-left',
    // 'waistPain-right',
    // 'restore',
    'upperArm-left',
    'foreArm-left',
    // 'upperArm-right',
    // 'foreArm-right'
  ]

  let facePain = getPainArr('face', data.conclusion, pains);
// 按身体部位绘制顺序取出每个部位的具体信息
  let faceOrderInfos = getOrderInfos(locationInfo, faceOrder);


  let faceImg = new Image();
  faceImg.src = imgSrc.bone.face;
  faceImg.onload = function() {
    //console.log('draw face !')
    let ctx = faceCanvas.getContext('2d');
    ctx.globalCompositeOperation  = 'destination-over'
    // 开始画头
    ctx.save();
    ctx.translate(0, 100);
    for(let i = 0; i < faceOrderInfos.length; i++) {
      if(faceOrderInfos[i].key == 'restore') {
        ctx.restore();
        continue;
      }

      if(faceOrderInfos[i].type !== 'pain' || (faceOrderInfos[i].type === 'pain' && facePain.indexOf(faceOrderInfos[i].key) !== -1)) {
        if(faceOrderInfos[i].saveBefore) {
          ctx.save();
        }

        ctx.translate(faceOrderInfos[i].translateX, faceOrderInfos[i].translateY);
        ctx.rotate(faceOrderInfos[i].rotateBefore);
        // if(faceOrderInfos[i].rotate > faceOrderInfos[i].maxRotate) {
        //   ctx.rotate(faceOrderInfos[i].maxRotate);
        // } else if (faceOrderInfos[i].rotate < faceOrderInfos[i].minRotate) {
        //   ctx.rotate(faceOrderInfos[i].minRotate);
        // } else {
          ctx.rotate(faceOrderInfos[i].rotate);
        // }

        if(faceOrderInfos[i].globalCompositeOperation) {
          ctx.globalCompositeOperation = faceOrderInfos[i].globalCompositeOperation;
        }
        ctx.drawImage(faceImg, faceOrderInfos[i].x, faceOrderInfos[i].y, faceOrderInfos[i].width, faceOrderInfos[i].height, faceOrderInfos[i].offsetW, faceOrderInfos[i].offsetH, faceOrderInfos[i].width, faceOrderInfos[i].height);

        ctx.globalCompositeOperation  = 'destination-over';

        if(faceOrderInfos[i].restoreAfter) {
          ctx.restore();
        }
      } else {
        continue;
      }
    }
  }
}

// ====== 侧面 ======
function drawBoneSide(data, canvas) {
  let sideCanvas = canvas;
  let sideWidth = sideCanvas.width;
  let sideHeight = sideCanvas.height;

  let sideRisks = data.conclusion.side.risks;

  let sidePoints = data.conclusion.side.points;
  let sideDirection = data.conclusion.side.side;
  let sideRad = {
    earToShoulder: getRad(sidePoints['ear'][sideDirection], sidePoints['shoulder'][sideDirection]),
    shoulderToElbow: getRad(sidePoints['shoulder'][sideDirection], sidePoints['elbow'][sideDirection]),
    elbowToWrist: getRad(sidePoints['elbow'][sideDirection], sidePoints['wrist'][sideDirection]),
    hipToKnee: getRad(sidePoints['hip'][sideDirection], sidePoints['knee'][sideDirection]),
    kneeToAnkle: getRad(sidePoints['knee'][sideDirection], sidePoints['ankle'][sideDirection])
  }

  let sideLocationInfo = {
    head: {
      mid: {
        key: 'head-mid',
        type: 'noraml',
        x: 1516,
        y: 71,
        width: 126,
        height: 168,
        offsetW: -63,
        offsetH: 0,
        translateX: sideWidth / 2,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false,
      },
      front: {
        key: 'head-front',
        type: 'noraml',
        x: 14,
        y: 91,
        width: 158,
        height: 168,
        offsetW: -79,
        offsetH: 0,
        translateX: sideWidth / 2,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false,
      }
    },
    body: {
      key: 'body',
      type: 'noraml',
      x: 1212,
      y: 85,
      width: 148,
      height: 300,
      offsetW: -74,
      offsetH: -25,
      translateX: isHeadFront(sideRisks) ? -21 : -6,
      translateY: 168,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: false,
      restoreAfter: false,
    },
    upperArm: {
      key: 'upperArm',
      type: 'noraml',
      x: 422,
      y: 89,
      width: 68,
      height: 178,
      offsetW: -34,
      offsetH: 0,
      translateX: -19,
      translateY: 0,
      rotateBefore: 0,
      rotate: sideRad.shoulderToElbow,
      maxRotate: 0.6,
      minRotate: -0.4,
      saveBefore: true,
      restoreAfter: false,
      globalCompositeOperation: 'source-over'
    },
    foreArm: {
      key: 'foreArm',
      type: 'noraml',
      x: 290,
      y: 85,
      width: 72,
      height: 244,
      offsetW: -15,
      offsetH: 0,
      translateX: 0,
      translateY: 155,
      rotateBefore: -getLimitRad(sideRad.shoulderToElbow, -0.4, 0.6),
      rotate: sideRad.elbowToWrist,
      maxRotate: 0,
      minRotate: -0.4,
      saveBefore: false,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shank: {
      key: 'shank',
      type: 'noraml',
      x: 920,
      y: 79,
      width: 126,
      height: 326,
      offsetW: -63,
      offsetH: 0,
      translateX: 5,
      translateY: 205,
      rotateBefore: 0,
      rotate: sideRad.hipToKnee,
      maxRotate: 0.1,
      minRotate: -0.1,
      saveBefore: true,
      restoreAfter: false,
      globalCompositeOperation: 'destination-over'
    },
    thigh: {
      key: 'thigh',
      type: 'noraml',
      x: 633,
      y: 79,
      width: 156,
      height: 286,
      offsetW: -58,
      offsetH: -15,
      translateX: 0,
      translateY: 326,
      rotateBefore: -getLimitRad(sideRad.hipToKnee, -0.1, 0.1),
      rotate: sideRad.kneeToAnkle,
      maxRotate: 0.1,
      minRotate: -0.1,
      saveBefore: false,
      restoreAfter: false,
      globalCompositeOperation: 'source-over'
    },
    neckBackPain: {
      key: 'neckBackPain',
      type: 'pain',
      x: 34,
      y: 519,
      width: 54,
      height: 88,
      offsetW: -27,
      offsetH: 0,
      translateX: -30,
      translateY: 70,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    neckMidPain: {
      key: 'neckMidPain',
      type: 'pain',
      x: 24,
      y: 1686,
      width: 96,
      height: 122,
      offsetW: 0,
      offsetH: 0,
      translateX: -60,
      translateY: -80,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shankMidPain: {
      key: 'shankMidPain',
      type: 'pain',
      x: 72,
      y: 1924,
      width: 82,
      height: 288,
      offsetW: -65,
      offsetH: 0,
      translateX: 0,
      translateY: 0,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shankLeftPain: {
      key: 'shankLeftPain',
      type: 'pain',
      x: 45,
      y: 1365,
      width: 44,
      height: 220,
      offsetW: 0,
      offsetH: 0,
      translateX: -40,
      translateY: 80,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    neckWithBosomPain: {
      key: 'neckWithBosomPain',
      type: 'pain',
      x: 24,
      y: 1077,
      width: 70,
      height: 176,
      offsetW: 0,
      offsetH: 0,
      translateX: -12,
      translateY: -120,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shoulderBackPain: {
      key: 'shoulderBackPain',
      type: 'pain',
      x: 241,
      y: 1076,
      width: 32,
      height: 176,
      offsetW: 0,
      offsetH: 0,
      translateX: -80,
      translateY: -15,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shankOPain: {
      key: 'shankOPain',
      type: 'pain',
      x: 212,
      y: 690,
      width: 80,
      height: 296,
      offsetW: 0,
      offsetH: 0,
      translateX: -60,
      translateY: 0,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    thighLeftPain: {
      key: 'thighLeftPain',
      type: 'pain',
      x: 0,
      y: 713,
      width: 42,
      height: 246,
      offsetW: 0,
      offsetH: 0,
      translateX: -60,
      translateY: -10,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    thighRightPain: {
      key: 'thighRightPain',
      type: 'pain',
      x: 40,
      y: 740,
      width: 40,
      height: 200,
      offsetW: 0,
      offsetH: 0,
      translateX: -10,
      translateY: 0,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    restore: {
      key: 'restore',
    }
  }
  let sideHeadDirection = isHeadFront(sideRisks) ? 'front' : 'mid';
  let sideOrder = [
    `head-${sideHeadDirection}`,
    'neckBackPain',
    'body',
    'neckWithBosomPain',
    'neckMidPain',
    'shoulderBackPain',
    'shank',
    'shankMidPain',
    'shankOPain',
    'shankLeftPain',
    'thigh',
    'thighLeftPain',
    'thighRightPain',
    'restore',
    'upperArm',
    'foreArm',
  ]

  let sideOrderInfos = getOrderInfos(sideLocationInfo, sideOrder);
// let sidePain = ['neckBackPain', 'shankMidPain', 'neckWithBosomPain', 'shoulderBackPain', 'shankOPain', 'shankLeftPain', 'thighLeftPain', 'thighRightPain', 'neckMidPain'];
  let sidePain = getPainArr('side', data.conclusion, pains);
  //console.log('sidePain ==>', sidePain);

  let sideImg = new Image();
  sideImg.src = imgSrc.bone.side;
  sideImg.onload = function() {
    let ctx = sideCanvas.getContext('2d');
    ctx.globalCompositeOperation  = 'destination-over'
    // 开始画头
    ctx.save();
    for(let i = 0; i < sideOrderInfos.length; i++) {
      if(sideOrderInfos[i].key == 'restore') {
        ctx.restore();
        continue;
      }

      if(sideOrderInfos[i].type !== 'pain' || (sideOrderInfos[i].type === 'pain' && sidePain.indexOf(sideOrderInfos[i].key) !== -1)) {
        // 非疼痛 或者 疼痛需要显示时
        //console.log('type =>', sideOrderInfos[i].type);
        //console.log('indexOf =>', sidePain.indexOf(sideOrderInfos[i].key))
        if(sideOrderInfos[i].saveBefore) {
          ctx.save();
        }

        ctx.translate(sideOrderInfos[i].translateX, sideOrderInfos[i].translateY);
        ctx.rotate(sideOrderInfos[i].rotateBefore);
        if(sideOrderInfos[i].rotate > sideOrderInfos[i].maxRotate) {
          ctx.rotate(sideOrderInfos[i].maxRotate);
        } else if (sideOrderInfos[i].rotate < sideOrderInfos[i].minRotate) {
          ctx.rotate(sideOrderInfos[i].minRotate);
        } else {
          ctx.rotate(sideOrderInfos[i].rotate);
        }

        if(sideOrderInfos[i].globalCompositeOperation) {
          ctx.globalCompositeOperation = sideOrderInfos[i].globalCompositeOperation;
        }
        ctx.drawImage(sideImg, sideOrderInfos[i].x, sideOrderInfos[i].y, sideOrderInfos[i].width, sideOrderInfos[i].height, sideOrderInfos[i].offsetW, sideOrderInfos[i].offsetH, sideOrderInfos[i].width, sideOrderInfos[i].height);

        ctx.globalCompositeOperation  = 'destination-over';

        if(sideOrderInfos[i].restoreAfter) {
          ctx.restore();
        }
      } else {
        continue;
      }
    }
  }
}

module.exports = {
  initRiskBar: initRiskBar,
  initRiskLevel: initRiskLevel,
  drawBoneFront: drawBoneFront,
  drawBoneSide: drawBoneSide,
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/canvas.js